module.exports = "https://cdn.realtymogul.com/static/media/due-diligence-hero.1a148e4e.jpg";